import React from 'react';
import PropTypes from 'prop-types';

import { FormModal, PlusCircleIcon } from '@metarouter-private/mr-mui';

import useAddTag from './useAddTag';
import TagLabelField from './TagLabelField';

export default function AddTagForm({ open, onClose }) {
  const { onSubmit } = useAddTag({ onClose });

  return (
    <FormModal
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      title="Add Tag"
      TitleIcon={PlusCircleIcon}
      submitLabel="Create Tag"
      validationMode="onChange"
    >
      <TagLabelField />
    </FormModal>
  );
}

AddTagForm.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
